import { Box, Button, Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useLiterals } from '~/components/Literals'
import actions from '../../actions'

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: -80,
    },
  },
  label: {
    whiteSpace: 'pre-wrap',
    textAlign: 'center',
    fontSize: 14,
  },
  button: {
    fontSize: 14,
    fontWeight: 700,
    textDecoration: 'underline',
  },
}))
const FilteredStoresNotFound = () => {
  const classes = useStyle()
  const dispatch = useDispatch()
  const { getLiteral } = useLiterals()
  const notFoundLabel = getLabel(getLiteral('3016'))

  const handleClearSelectedSegments = (e) => {
    dispatch(actions.clearSegments())
  }

  return (
    <Box className={classes.root}>
      <Typography className={classes.label}>{notFoundLabel}</Typography>
      <Button className={classes.button} variant="text" onClick={handleClearSelectedSegments}>
        {getLiteral('1788')}
      </Button>
    </Box>
  )
}

function getLabel(label) {
  const words = label.split(' ')
  const lastWord = words.pop()
  words.push('\n')
  words.push(lastWord)

  return words.join(' ')
}

export default FilteredStoresNotFound
